import axios from 'axios';
import { store } from './store';

import { parseISO, format } from 'date-fns';

const { REACT_APP_APIBRANDURL } = process.env

const API_URL = REACT_APP_APIBRANDURL


export const apiAxios = axios.create({
    baseURL: API_URL
});

const store_data = JSON.parse(store());
// console.log(store_data)

const getToken = async () => {
    // The login API returns access_token, not token
    return store_data?.access_token;
};

const getConfig = async () => {
    const token = await getToken();
    // console.log("token", token)
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    };
};

const getConfigForm = async () => {
    const token = await getToken();
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        }
    };
};

export const postAPI = async (apiName, data) => {
    const response = await apiAxios.post(apiName, { ...data }, await getConfig());
    if (response?.data?.status == 0 && response?.data?.is_login == 0) {
        window.location.href = '/logout'
    } else {
        return response.data;
    }
};

export const postAPIForm = async (apiName, data) => {
    const response = await apiAxios.post(apiName, data, await getConfigForm());
    if (response?.data?.status == 0 && response?.data?.is_login == 0) {
        window.location.href = '/logout'
    } else {
        return response.data;
    }
};

export const getAPI = async (route) => {
    console.log(await getConfig())
    const res = await apiAxios.get(route, await getConfig());
    return res.data;
}

export const getURL = () => {
    return {
        "API": API_URL
    }
};

export const formatDate = (dateString) => {
    const date = parseISO(dateString);
    const day = format(date, 'd');
    const month = format(date, 'MMM');
    const year = format(date, 'yyyy');
    return { day, month, year }
};

export const convertTo24Hour = (time12h) => {
    const [time, modifier] = time12h.trim().split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier.toLowerCase() === 'pm' && hours !== 12) {
        hours += 12;
    } else if (modifier.toLowerCase() === 'am' && hours === 12) {
        hours = 0;
    }

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}


export const convertTo12Hour = (time24h) => {
    let [hours, minutes] = time24h.split(':').map(Number);
    const modifier = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${hours}:${String(minutes).padStart(2, '0')} ${modifier}`;
}


export const splitISODateTime = (isoString) => {
    if (!isoString || typeof isoString !== 'string') return [null, null];

    const [datePart, timePart] = isoString.split('T');

    const date = datePart; // "2025-05-04"
    const time = timePart ? timePart.split('.')[0] : null; // "14:30:00" (without milliseconds)

    return [date, time];
}

